var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOtherTools(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170.891,
    height: 184.289,
    viewBox: "0 0 45.215 48.76",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M643.845 127.183h34.79v37.518h-34.79Z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.29965 0 0 -1.29965 -836.771 214.053)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M658.61 157.317c-6.794-1.924-10.125-9.782-6.729-15.982 3.347-6.27 11.925-8.198 17.313-3.338.471.418.898.879 1.279 1.372l-.06-.013-.208.507a10.46 10.46 0 0 0-.636-.71c-5.8-6.003-15.91-3.953-18.178 4.297-1.322 4.827 1.004 10.164 5.484 12.41 4.018 2.112 8.93 1.34 12.195-1.452l.223.17c-2.733 2.667-6.731 3.887-10.684 2.739",
    style: {
      fill: "#175583",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.288 141.08c-1.115-3.088-3.085-5.876-5.724-7.938-11.05-8.643-27.038-2.04-28.18 12.09-.808 10.872 8.457 19.822 19.287 18.688 4.179-.408 8.074-2.354 10.926-5.314l.19.145c-4.4 4.884-11.336 7.223-18.04 5.25-10.82-3.066-16.145-15.56-10.81-25.47 3.833-7.372 12.748-11.343 20.772-9.05 5.927 1.61 10.212 6.192 11.926 11.674z",
    style: {
      fill: "#70bde5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.69 158.04c-5.337-4.248-6.917-11.916-3.653-17.906 4.29-8.107 15.324-10.496 22.258-4.266a13.48 13.48 0 0 1 3.268 4.396l-.517-.113a14.208 14.208 0 0 0-3.66-4.281c-8.855-6.913-21.635-1.69-22.524 9.657-.619 8.686 6.77 15.81 15.42 14.924 3.225-.308 6.247-1.754 8.514-3.973l.207.158c-4.847 5.197-13.137 6.339-19.314 1.405",
    style: {
      fill: "#4993c1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.563 146.59a3.926 3.926 0 1 0-7.853 0 3.926 3.926 0 0 0 7.853 0",
    style: {
      fill: "#175583",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m660.521 155.425-1.115 1.932 1.115 1.932h2.231l1.116-1.932-1.116-1.932z",
    style: {
      fill: "#e95329",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m659.778 127.183-1.971 3.414 1.97 3.413h3.942l1.971-3.413-1.97-3.414z",
    style: {
      fill: "#a72f62",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m648.984 147.725 1.932 1.115 1.932-1.115v-2.23l-1.932-1.116-1.932 1.115z",
    style: {
      fill: "#1e6eac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m669.218 141.767 2.155-.577.578-2.155-1.578-1.577-2.155.577-.577 2.155z",
    style: {
      fill: "#70bde5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m648.618 162.171 4.435-1.188 1.188-4.435-3.247-3.246-4.434 1.188-1.188 4.435z",
    style: {
      fill: "#fbbc00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m668.505 160.612.09 2.23 1.974 1.037 1.886-1.192-.09-2.229-1.974-1.037z",
    style: {
      fill: "#99c22e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m645.042 135.221 1.448 4.237 4.394.864 2.944-3.373-1.448-4.236-4.393-.864z",
    style: {
      fill: "#009149",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherTools);
export default __webpack_public_path__ + "static/media/other_tools.76146524fb286a8bbf00a7c558ce43d0.svg";
export { ForwardRef as ReactComponent };